import IwLink from '@iwRouter/IwLink';

export const BreadCrumb = ({
    children,
    url,
    final
}: {
    children: React.ReactNode;
    url?: string;
    final?: boolean;
}) => {
    return (
        <span className="flex gap-m">
            {url ? (
                <IwLink
                    to={url}
                    className="text-s font-reg !text-primary-40 underline"
                >
                    {children}
                </IwLink>
            ) : (
                <span className="text-s font-reg">{children}</span>
            )}
            {!final && <span className="">/</span>}
        </span>
    );
};
